/* unplugin-vue-components disabled */import { render } from "./KilaKilaLightBox.vue?vue&type=template&id=3c0ad7b6&scoped=true"
import script from "./KilaKilaLightBox.vue?vue&type=script&lang=js"
export * from "./KilaKilaLightBox.vue?vue&type=script&lang=js"

import "./KilaKilaLightBox.vue?vue&type=style&index=0&id=3c0ad7b6&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0ad7b6"]])

export default __exports__